import moment from 'moment';

export function getDay(date) {
  var dt = moment(date, 'dddd');
  return dt.format('dddd').toString();
}

export function getSlot(start_tm, end_tm) {
  return start_tm + '-' + end_tm;
}
export function aggregateByTeacher(
  allClassrooms,
  allTeachers,
  teacherIdList,
  teacherSlots,
) {
  var classrooms;
  var outputData = {};
  teacherIdList.forEach(teacherId => {
    outputData[teacherId] = {
      id: teacherId,
      name: allTeachers[teacherId].first_name + ' ' + allTeachers[teacherId].last_name,
      phone: allTeachers[teacherId].phone,
      totalCallTime: [],
      totalNumDoubts: 0,
      numItemsAttempted: 0,
      itemsAttemptedCorrectly: [],
      accuracy: [],
      numPresent: 0,
      numAbsent: 0,
      numTeacherAbsent: 0,
      timeOnWorksheets: [],
      perSlot: {},
      ratings: {
        ratingVals: [],
        posFeedback: {},
        negFeedback: {},
      },
      studentIdDict: {},
    };
    classrooms = allClassrooms.filter(clsrm => clsrm.teacher_id === teacherId);
    if (classrooms.length > 0) {
      classrooms.forEach(cls => {
        var day = getDay(cls.date);
        var slot = getSlot(cls.scheduled_start_time, cls.scheduled_end_time);
        // Get itemsAttempted, timeOnWorksheets from cls.sessions_attempted
        var scoreToday = 0;
        var maxScoreToday = 0;
        var itemsAttempted = 0;
        var timeOnWorksheets = 0;
        var itemsAttemptedCorrectly = 0.0;
        outputData[teacherId]['studentIdDict'][cls.student_id] = 1;
        Object.values(cls.sessions_attempted).forEach(ssn => {
          itemsAttempted += ssn.num_attempted_today;
          if (ssn.max_score !== 0) {
            itemsAttemptedCorrectly +=
              parseFloat(ssn.num_attempted_today * ssn.score) / ssn.max_score;
          }
          timeOnWorksheets += ssn.time_spent;
          scoreToday += ssn.score;
          maxScoreToday += ssn.max_score;
        });
        if (!outputData[teacherId]['perSlot'][day]) {
          outputData[teacherId]['perSlot'][day] = {};
        }
        if (!outputData[teacherId]['perSlot'][day][slot]) {
          outputData[teacherId]['perSlot'][day][slot] = {};
        }
        outputData[teacherId]['perSlot'][day][slot][cls.student_id] = {
          rating: cls.rating,
          status: cls.status,
          totalCallDuration: cls.total_call_duration,
          numDoubts: cls.num_doubt_button_presses,
          doubtCallTimeList: cls.doubt_to_call_time_list,
          scoreToday: scoreToday,
          maxScoreToday: maxScoreToday,
          itemsAttempted: itemsAttempted,
          timeOnWorksheets: timeOnWorksheets,
        };
        outputData[teacherId]['totalNumDoubts'] += cls.num_doubt_button_presses;
        outputData[teacherId]['numItemsAttempted'] += itemsAttempted;
        if (maxScoreToday !== 0) {
          let accuracy = parseFloat(scoreToday) / maxScoreToday;
          outputData[teacherId]['accuracy'].push(accuracy);
          outputData[teacherId]['itemsAttemptedCorrectly'].push(itemsAttemptedCorrectly);
        }
        outputData[teacherId]['timeOnWorksheets'].push(timeOnWorksheets);
        if (cls.ratings) {
          // console.log('ERROR HERE', cls.ratings);
          if (!cls.ratings.rating) {
            console.log('What does it mean', cls.ratings);
          }
          if (cls.ratings.rating) {
            outputData[teacherId]['ratings']['ratingVals'].push(cls.ratings.rating);
          }
          let feedbackObj = JSON.parse(cls.ratings.meta);
          if (feedbackObj.feedback_tags) {
            if (cls.ratings.rating >= 5) {
              feedbackObj.feedback_tags.forEach(tg => {
                if (outputData[teacherId]['ratings']['posFeedback'][tg]) {
                  outputData[teacherId]['ratings']['posFeedback'][tg] += 1;
                } else {
                  outputData[teacherId]['ratings']['posFeedback'][tg] = 1;
                }
              });
            } else {
              feedbackObj.feedback_tags.forEach(tg => {
                if (outputData[teacherId]['ratings']['negFeedback'][tg]) {
                  outputData[teacherId]['ratings']['negFeedback'][tg] += 1;
                } else {
                  outputData[teacherId]['ratings']['negFeedback'][tg] = 1;
                }
              });
            }
          }
        }
        outputData[teacherId]['totalCallTime'].push(cls.total_call_duration);
        if (cls.status === 'P') {
          outputData[teacherId]['numPresent'] += 1;
        } else if (cls.status === 'A') {
          outputData[teacherId]['numAbsent'] += 1;
        } else if (cls.status === 'TA') {
          outputData[teacherId]['numTeacherAbsent'] += 1;
        }
        // console.log('aggregateByTeacher', teacherId, classrooms, allTeachers[teacherId]);
      });
    }
    outputData[teacherId]['studentSlot'] = [];
    outputData[teacherId]['numStudents'] = Object.keys(
      outputData[teacherId]['studentIdDict'],
    ).length;
  });
  teacherSlots.forEach(slt => {
    slt.teachers.forEach(tch => {
      if (teacherIdList.includes(tch.teacher_id)) {
        if (tch.students_count !== 0) {
          outputData[tch.teacher_id]['studentSlot'].push(tch.students_count);
        }
      }
    });
  });
  var finalOutput = Object.entries(outputData).map(([teacherId, tchData]) => ({
    id: teacherId,
    ...tchData,
  }));
  return finalOutput;
}

export const median = arr => {
  const mid = Math.floor(arr.length / 2),
    nums = [...arr].sort((a, b) => a - b);
  return arr.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};
